module.exports = __webpack_public_path__ + "media/images/admin/icons/minimize-5862b48d9c4e55a14ffbced675a84345.svg";